import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IsLoadingDirective } from './is-loading/is-loading.directive';
import { ShareDirective } from './share/share.directive';
import { UnitDirective } from './unit/unit.directive';

@NgModule({
  imports: [CommonModule, ShareDirective, UnitDirective, IsLoadingDirective],
  exports: [ShareDirective, UnitDirective, IsLoadingDirective],
})
export class DirectivesModule {}
